export const ARCHIVE_FILES_LIMIT_COUNT = 1000

export const ARCHIVE_FILES_LIMIT_SIZE = 2 * 1024 * 1024 * 1024 // 2GB in bytes

export const TASK_STATUS_INTERVAL = 2000
